

export class StorageDaysUpdateInput implements IStorageDaysUpdateInput {
    /** The auto-generated id of the storage days master */
    storageDaysId!: number;
    /** The storage days name with 255 character limit */
    storageDaysName!: string;

    constructor(data?: IStorageDaysUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storageDaysId = _data["storageDaysId"];
            this.storageDaysName = _data["storageDaysName"];
        }
    }

    static fromJS(data: any): StorageDaysUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new StorageDaysUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storageDaysId"] = this.storageDaysId;
        data["storageDaysName"] = this.storageDaysName;
        return data; 
    }
}

export interface IStorageDaysUpdateInput {
    /** The auto-generated id of the storage days master */
    storageDaysId: number;
    /** The storage days name with 255 character limit */
    storageDaysName: string;
}

